export default {
  nav: {
    bottomNav: {
      home: 'Home',
      record: 'Record',
      calendar: 'Calendar',
      vevo: 'VEVO',
      settings: 'Settings',
    },
  },
  vevo: {
    reportFallback: 'Report',
    intro: {
      greeting: 'Dear parents',
      line1: 'Here we share your child\'s',
      line2: 'growth in daily life',
      line3: 'once every 3 months!',
    },
    listTitle: 'Reports',
    empty: {
      line1: 'No reports have arrived yet.',
      line2: 'Stay tuned for the next quarter!',
    },
    publishedAt: 'Published {date}',
    detail: {
      title: 'VEVO Report',
      notFound: 'Report not found.',
      monthRange: 'months {start}–{end}',
      coverageNote: 'This report is generated from the data available in {range}.',
      caution: '* This text is based on your child\'s growth as reviewed by nursery teachers, but it may contain incorrect information due to differences in how AI interprets the data.',
      language: 'Display language',
      languages: {
        en: 'English',
        ja: 'Japanese',
        km: 'Khmer',
        vi: 'Tiếng Việt',
        ko: 'Korean',
        zh: 'Chinese',
        hi: 'Hindi',
        ru: 'Russian',
        bn: 'Bengali',
        mn: 'Mongolian',
        tl: 'Tagalog',
        ms: 'Malay',
      },
    },
  },
  validation: {
    required: 'This field is required',
    choice2: 'Please select 2 options',
    counter: 'Please enter within 20 characters',
    counter2: 'Please enter 2 characters',
    counter3: 'Please enter 3 characters',
    counterMin4: 'Please enter within 4 characters',
    counter14to16: 'Please enter 14-16 characters',
    counter100: 'Please enter within 100 characters',
    counter500: 'Please enter within 500 characters',
    counter1000: 'Please enter within 1000 characters',
    typeNumber: 'Please enter a valid number',
    typeStringNumber: 'Please enter a valid number',
    email: 'Please enter a valid email address',
    phoneNumber: 'Invalid phone number format',
    postalCode: 'Invalid postal code format',
    integerThan0: 'Please enter a non-negative integer',
    multipleSelectRequired: 'This field is required',
    typeKana: 'Please enter in Katakana',
    typeKanaFullWidth: 'Please enter in full-width Katakana',
    typeHiraganaFullWidth: 'Please enter in full-width Hiragana',
    typeAlphabet: 'Please enter in half-width letters',
  },
  setting: {
    growth: 'Growth Record',
    invoice: 'Invoice',
    variousSettings: 'Various Settings',
    familySettings: 'Family Settings',
    paymentSettings: 'Payment Settings',
    notificationSettings: 'Notification Settings',
    languageSettings: 'Language Settings',
    logout: 'Logout',
  },
  settingLanguage: {
    title: 'Language Settings',
    save: 'Save',
    successMessage: 'Language setting saved',
    languages: {
      english: 'English',
      khmer: 'ភាសាខ្មែរ (Khmer)',
      japanese: '日本語 (Japanese)',
    },
  },
  invoice: {
    selectTitle: 'Invoices',
  },
  settingFamily: {
    title: 'Family Settings',
    guardians: 'Guardians',
    you: 'You',
    inviteGuardian: 'Invite another guardian',
    children: 'Children',
    addChild: 'Add a child',
    familyInfo: 'Family Information',
    parentType: {
      mother: 'Mother',
      father: 'Father',
      grandma: 'Grandmother',
      granpa: 'Grandfather',
      uncle: 'Uncle',
      aunt: 'Aunt',
      sister: 'Sister',
      brother: 'Brother',
      other: 'Other',
    },
  },
  parentEdit: {
    save: 'Save',
    lastName: 'Last name',
    firstName: 'First name',
    lastNameKana: 'Last name (Kana)',
    firstNameKana: 'First name (Kana)',
    deleteAccount: 'Delete this guardian account',
    successMessage: 'Registration completed',
    bloodType: {
      a: 'A type',
      b: 'B type',
      o: 'O type',
      ab: 'AB type',
      unknown: 'Unknown',
    },
  },
  parentAdd: {
    title: 'Invite Family',
    emailLabel: 'Email address',
    parentTypeLabel: 'Guardian type',
    noticeSignup: '*The invited person must sign up using the email address entered above.',
    noticeSpam: '*Sign-up (registration) is possible even if the invitation email was filtered as spam.',
    submit: 'Send',
    invitedEmails: 'Invited email addresses',
    inviteSuccess: 'Invitation completed',
    parentType: {
      mother: 'Mother',
      father: 'Father',
      grandma: 'Grandmother',
      granpa: 'Grandfather',
      uncle: 'Uncle',
      aunt: 'Aunt',
      other: 'Other',
    },
  },
  childEdit: {
    processing: 'Processing. Please wait...',
    save: 'Save',
    lastName: 'Last name',
    firstName: 'First name',
    lastNameKana: 'Last name (Kana)',
    firstNameKana: 'First name (Kana)',
    successMessage: 'Saved successfully',
  },
  childrenGrowth: {
    save: 'Save',
    successMessage: 'Registration completed',
  },
  childAdd: {
    title: 'Add Child',
    childIdLabel: "Child's ID",
    password: 'Password',
    submit: 'Add child',
    successMessage: 'Registration completed',
  },
  meCreate: {
    tapToChange: 'Tap to change',
    lastName: 'Last name',
    firstName: 'First name',
    lastNameKana: 'Last name (Kana)',
    firstNameKana: 'First name (Kana)',
    birthDate: 'Date of birth',
    bloodType: 'Blood type',
    phoneNumber: 'Phone number',
    submit: 'Submit',
  },
  familyCreate: {
    description: {
      line1: 'This screen appears when registering with a child for the first time.',
      line2: 'If you have used CCSHOME before, you are trying to log in with an email address different from the one used during initial registration.',
      line3: 'Please tap logout once, then log in using the account and login method used during initial registration.',
      line4: 'If this is your first registration, please enter the child ID and password listed in the guidance notice below.',
    },
    childId: "Child's ID",
    password: 'Password',
    parentType: 'Guardian type',
    submit: 'Send',
    logout: 'Logout',
  },
  familyEdit: {
    title: 'Edit Family Info',
    familyName: 'Family name',
    save: 'Save',
    successMessage: 'Registration completed',
  },
  settingNotification: {
    title: 'Notification Settings',
    save: 'Save',
    successMessage: 'Registration completed',
    options: {
      both: 'Both',
      pushOnly: 'Push Only',
      emailOnly: 'Email Only',
      none: 'None',
    },
    notifications: {
      absentConfirmed: 'Absence notice',
      pickupConfirmed: 'Pickup change',
      pickupConfirmedTitle: 'Pickup change has been confirmed!',
      chatReceived: 'Chat',
      chatReceivedTitle: 'New message has arrived!',
      growthUpdated: 'Growth record update',
      invoiceSettled: 'Invoice issued',
      creditSettled: 'Credit card charge',
      creditFailed: 'Credit card charge failed',
    },
  },
  growth: {
    memory: 'Record',
    graph: 'Graph',
    nendo: 'Year',
    implementationMonth: 'Month',
    height: 'Height',
    weight: 'Weight',
    noData: 'No data available',
    show: 'Show',
    remarks: 'Remarks',
    close: 'Close',
    percentileRange: 'Percentile values in 3% ~ 97% range',
  },
  calendar: {
    prevMonth: 'Previous Month',
    nextMonth: 'Next Month',
    dateFormat: '{month}/{day}',
    dateFormatFull: '{year}/{month}/{day} ({dayOfWeek})',
    monthName: '{month}',
    defecation: {
      hard: 'Hard',
      normal: 'Normal',
      soft: 'Soft',
      diarrhea: 'Watery (Diarrhea)',
    },
  },
  home: {
    loadingReleaseInfo: 'Loading release information…',
    loadMore: 'Load more',
    newAnnouncement: 'You have new announcements!',
    fabReleaseInfo: 'Release info',
    fabAbsence: 'Absence notice',
    fabPickup: 'Pickup change',
    qrBarcodeHint: 'Hold the barcode above over the dedicated device.',
  },
  common: {
    cancel: 'Cancel',
    submit: 'Send',
    delete: 'Delete',
    unknown: 'Unknown',
  },
  emailSendModal: {
    title: 'Confirm Email Recipient',
    emailLabel: 'Recipient email address',
    notice: {
      line1: '* The attachment file will be sent by email.',
      line2: '* Please make sure the recipient address is correct.',
    },
    cancel: 'Cancel',
    submit: 'Send Email',
    success: 'Email sent successfully',
    errors: {
      unavailable: 'Sorry, this feature is currently unavailable.',
      emailRequired: 'Email address is not entered',
    },
  },
  translationModal: {
    title: 'Select language',
    cancel: 'Cancel',
    submit: 'Translate',
    success: 'Translation completed',
    failure: 'Translation failed',
  },
  accountDelete: {
    title: 'Warning!',
    description: {
      line1: 'If you delete your account, you will no longer be able to log in with this account and all of the following information will be lost.',
      line2: '*You will also no longer be able to log in to MEMORU.',
    },
    items: {
      records: 'All records in the communication notebook',
      chat: 'Chat history',
      growth: 'All growth record data',
      invoices: 'All received invoices',
      memoru: 'All MEMORU data',
    },
    continue: 'Continue',
    reasonPrompt: 'Please enter the reason for deletion.',
  },
  record: {
    menu: {
      chat: 'Chat',
      todayRecord: "Today's record",
      references: 'Notices/Resources',
      vevo: 'VEVO report',
    },
    date: {
    yearSuffix: '{year}',
    month: '{month}',
      monthDay: '{day}/{month}',
      prevDay: 'PREVIOUS DAY',
      nextDay: 'NEXT DAY',
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
      editedAt: '(edited {time})',
    },
    section: {
      nurseryRecord: 'Nursery records',
      homeRecord: 'Home records',
      attendance: 'Attendance time',
      sleep: 'Sleep',
      meal: 'Meal',
      mealComment: 'Comment',
      defecation: 'Defecation',
      milk: 'Milk',
      temperature: 'Temperature',
      breakfast: 'Breakfast',
      dinner: 'Dinner',
      childRecord: "Child's note",
    },
    meal: {
      stapleFood: 'Staple food',
      mainDish: 'Main dish',
      sideDish: 'Side dish',
      soup: 'Soup',
      dessert: 'Dessert',
      milk: 'Milk',
      snack: 'Snack',
      commentPlaceholder: 'Enter a comment',
      actions: {
        finishAll: 'Finish all',
        addRecord: '+ Add record',
      },
    },
    action: {
      addSleep: 'Add sleep record',
      addTemperature: 'Add temperature record',
      addBreakfast: 'Add breakfast record',
      addDinner: 'Add dinner record',
      addMilk: 'Add milk record',
      addDefecation: 'Add defecation record',
      saveDraft: 'Save draft',
    },
    status: {
      milkFormula: 'Formula',
      milkBreast: 'Breast milk',
      defecationHard: 'Hard',
      defecationNormal: 'Normal',
      defecationSoft: 'Soft',
      defecationDiarrhea: 'Watery (Diarrhea)',
      mealRefill: 'Refill',
      mealFinished: 'Finished',
      mealUnfinished: 'Left some',
      mealHalf: 'Half',
      mealLittle: 'A little',
      mealNotEat: 'Did not eat',
      mealNotServed: 'Not served',
    },
    modal: {
      sleepTitle: 'Sleep',
      sleepStart: 'Start',
      sleepEnd: 'End',
      breakfastTitle: 'Breakfast',
      dinnerTitle: 'Dinner',
      milkTitle: 'Milk',
      milkTime: 'Time',
      milkType: 'Type',
      milkAmount: 'Amount',
      defecationTitle: 'Defecation',
      defecationTime: 'Time',
      defecationState: 'Condition',
      temperatureTitle: 'Temperature',
      temperatureTime: 'Time',
      temperatureValue: 'Temperature',
    },
    confirm: {
      deleteRecord: 'Delete this record?',
    },
    toast: {
      deleted: 'Deleted successfully',
      updated: 'Updated successfully',
    },
  },
  references: {
    datePicker: {
      title: 'Select year and month',
      year: 'Year',
      month: 'Month',
      apply: 'Apply',
    },
    detail: {
      date: 'Date',
      title: 'Title',
      body: 'Body',
      attachments: 'Attachments',
      view: 'View',
      iframeNotSupported: 'Your browser does not support iframes.',
      downloadPdf: 'Download PDF',
      close: 'Close',
    },
  },
  chat: {
    header: {
      record: 'Record',
      prevDay: 'PREVIOUS DAY',
      nextDay: 'NEXT DAY',
      year: '{year}',
    },
    tabs: {
      chat: 'Chat',
      absence: 'Absence notice',
      pickup: 'Pickup',
    },
    menu: {
      delete: 'Delete',
      copy: 'Copy',
    },
    message: {
      read: 'Read',
      groupChatLabel: '[Announcement]\n',
      showAttachment: 'Show attachment',
      sendAttachmentByEmail: 'Send attachment by email',
    },
    input: {
      send: 'Send',
    },
    absence: {
      title: 'Absence notice',
      reasons: {
        fever: 'Fever',
        personal: 'Family reasons',
        infection: 'Infectious disease',
        others: 'Other',
        othersWithComment: 'Other (comment required)',
        infStrep: 'Strep throat',
        infMycoplasma: 'Mycoplasma pneumonia',
        infHFMD: 'Hand, foot, and mouth disease',
        infSlappedCheek: 'Fifth disease (slapped cheek)',
        infStomach: 'Viral gastroenteritis (norovirus, rotavirus, adenovirus, etc.)',
        infHerpangina: 'Herpangina',
        infRS: 'RS virus infection',
        infZoster: 'Shingles',
        infRoseola: 'Roseola',
        infImpetigo: 'Impetigo',
        covid19: 'COVID-19',
      },
    },
    absenceModal: {
      title: 'Absence notice',
      fields: {
        period: 'Period',
        reason: 'Reason',
        detail: 'Details',
        comment: 'Comment',
      },
      actions: {
        ok: 'OK',
      },
      reasons: {
        fever: 'Fever',
        personal: 'Family reasons',
        infection: 'Infectious disease',
        others: 'Other (comment required)',
      },
      infections: {
        infStrep: 'Strep throat',
        infMycoplasma: 'Mycoplasma pneumonia',
        infHFMD: 'Hand, foot, and mouth disease',
        infSlappedCheek: 'Fifth disease (slapped cheek)',
        infStomach: 'Viral gastroenteritis (norovirus, rotavirus, adenovirus, etc.)',
        infHerpangina: 'Herpangina',
        infRS: 'RS virus infection',
        infZoster: 'Shingles',
        infRoseola: 'Roseola',
        infImpetigo: 'Impetigo',
        covid19: 'COVID-19',
      },
    },
    pickup: {
      title: 'Pickup Change',
      dropOffBy: 'Drop-off by: ',
      dropOffTime: 'Drop-off time: ',
      pickupBy: 'Pickup by: ',
      pickupTime: 'Pickup time: ',
    },
    pickupModal: {
      title: 'Pickup Change',
      tabs: {
        dropOff: 'Drop-off',
        pickup: 'Pickup',
      },
      fields: {
        date: 'Date',
        dropOffBy: 'Drop-off person',
        dropOffTime: 'Drop-off time',
        pickupBy: 'Pickup person',
        pickupTime: 'Pickup time',
        reason: 'Reason',
      },
      parentRelation: {
        Mother: 'Mother',
        Father: 'Father',
        Grandmother: 'Grandmother',
        Grandfather: 'Grandfather',
        Uncle: 'Uncle',
        Aunt: 'Aunt',
        Sister: 'Sister',
        Brother: 'Brother',
        Other: 'Other',
      },
    },
    action: {
      cancel: 'Delete',
      close: 'Close',
      cancelBtn: 'Cancel',
    },
    confirm: {
      deleteTitle: 'Delete this message?',
    },
    toast: {
      copied: 'Copied',
      deleteCompleted: 'Deleted successfully',
    },
  },
  noEmailVerified: {
    title: 'A verification email has been sent.',
    description: 'Please follow the steps below to log in.',
    step1: 'Tap "Verify Account" in the email to open Chrome browser.',
    step2: 'Tap "Allow" on the displayed message.',
    step3: 'Open the CCS HOME app, and the ID and password registration screen for your child will be displayed.',
    step4: 'Proceed with the registration.',
    noEmailTitle: 'If you did not receive the email:',
    noEmailDescription: 'Please check if the email was automatically sorted into your spam or junk folder.',
    loginButton: 'Log In',
    reLoginButton: 'Log In with a Different Account',
  },
  error: {
    default: 'An unexpected error occurred. Please try again later or contact customer support.',
    invalidParams: 'Invalid parameters.',
    tokenExpired: 'Your session has expired.',
    userNotFound: 'User not found.',
    userAlreadyExists: 'This user already exists.',
    invalidObjectType: 'Invalid object type specified.',
    breakfastNotFound: 'Breakfast record not found.',
    breakfastAlreadyExists: 'Breakfast record already exists.',
    dinnerNotFound: 'Dinner record not found.',
    dinnerAlreadyExists: 'Dinner record already exists.',
    bowelMovementNotFound: 'Defecation record not found.',
    milkNotFound: 'Milk record not found.',
    sleepNotFound: 'Sleep record not found.',
    temperatureNotFound: 'Temperature record not found.',
    childcareJournalNotFound: 'Childcare journal record not found.',
    childcareJournalAlreadyExists: 'Childcare journal record already exists.',
    eatingRecordNotFound: 'Eating record not found.',
    eatingRecordAlreadyExists: 'Eating record already exists.',
    absenceOverlap: 'Cannot register due to overlapping absence periods.',
    invalidReason: 'Selected reason is invalid.',
    invalidPickedUpPerson: 'Selected pickup person is invalid.',
    messageNotFound: 'Message not found.',
    pickupDataNotFound: 'Pickup data not found.',
    classNotFound: 'Class not found.',
    childNotFound: 'Child not found. Please check the child ID and password and try again.',
    childAlreadyRegistered: 'This child is already registered in your family.',
    familyNotFound: 'Specified family not found.',
    userNotInFamily: 'User does not belong to the specified family.',
    userAlreadyInvited: 'The specified user has already been invited to the family.',
    formatNotFound: 'Specified format not found.',
    childIdNotSpecified: 'Child ID is not specified.',
    feedInfoNotFound: 'Specified feed information does not exist.',
    feedDetailNotFound: 'Specified feed detail information does not exist.',
    reportNotOwned: 'The specified report does not belong to this user.',
    arrivalDepartureAlreadyExists: 'Arrival/departure record already exists for this date.',
    arrivalDepartureNotFound: 'Arrival/departure record not found.',
    arrivalRecordNotFound: 'Arrival record not found for the specified date.',
    arrivalRecordAlreadyExists: 'Arrival record already exists for the specified date.',
    departureRecordAlreadyExists: 'Departure record already exists for the specified date.',
    arrivalDepartureNotOwned: 'This arrival/departure record does not belong to this child.',
    invalidNursery: 'Invalid nursery specified.',
    hiraganaCheckFailed: 'Failed to check hiragana. Please contact us.',
    invalidInternalId: 'Internally used ID is invalid.',
    invalidUqid: 'uqid is invalid.',
    invalidChecksum: 'Checksum is invalid.',
    userNotInNursery: 'User does not belong to the specified nursery.',
    adminOnly: 'Only administrator users are allowed to perform this operation.',
    invalidApprovalStatus: 'Journal approval status is invalid.',
    nurseryDiaryNotFound: 'Nursery diary record not found.',
    menuNotOwned: 'The specified menu does not belong to this nursery.',
    userNotInNursery2: 'User does not belong to the specified nursery.',
    adminOnly2: 'Only administrator users are allowed to perform this operation.',
    invalidApprovalStatus2: 'Journal approval status is invalid.',
    nurseryDiaryNotFound2: 'Nursery diary record not found.',
    noApprovalPermission: 'This user does not have approval permission.',
    applicantMismatch: 'The applicant of this journal is not this user.',
    journalNotPending: 'This journal is not in pending status.',
    alreadyApproved: 'Another user has already approved with the same permission.',
    initialJournalStatus: 'The initial state of the journal must be either pending or draft.',
    photoRecordNotFound: 'Photo record not found.',
    userNotInNursery3: 'This user does not belong to the nursery of the specified menu.',
    foodInspectionAlreadyExists: 'Food inspection record already exists for this menu.',
    foodInspectionNotFound: 'Specified food inspection record does not exist.',
    annualEventNotFound: 'Specified annual event does not exist.',
    classIdNotOwned: 'The specified class ID does not belong to this nursery.',
    invalidSocketId: 'SocketId format is invalid. Please contact the system administrator.',
    napCheckPatternNotFound: 'Nap check pattern does not exist.',
    duplicateStaff: 'Assigned staff is duplicated.',
    staffNotInNursery: 'The specified staff does not belong to this nursery.',
    napPatternNotOwned: 'This nap check pattern does not belong to this nursery.',
    childNotInNursery: 'This child does not belong to this nursery.',
    napCheckNotFound: 'Nap check does not exist.',
    napCheckNotOwned: 'This nap check does not belong to this nursery.',
    napCheckTempHumidityNotFound: 'Temperature/humidity data for this nap check does not exist.',
    napCheckNotPending: 'This nap check record is not in pending status.',
    childAlreadyInNapCheck: 'A child already in this nap check record cannot be specified.',
    childNotInNapCheck: 'A child not in this nap check record cannot be specified.',
    staffAlreadyInNapCheck: 'A staff already in this nap check record cannot be specified.',
    napCheckCannotEdit: 'Nap check records in completed or pending status cannot be edited.',
    napCheckDetailNotFound: 'The specified nap check individual record does not exist.',
    napCheckDetailNotOwned: 'The specified nap check individual record does not belong to this nursery.',
    napCheckDetailAlreadyExists: 'The specified nap check individual record already exists.',
    childNotInNapCheck2: 'The specified child is not included in this nap check.',
    invalidEventTime: 'Event time specification is invalid.',
    noRelation: 'No relation.',
    napSensorNotFound: 'Nap sensor does not exist.',
    commentLimit: 'Comments must be within 1000 characters.',
    absenceConfirmationFailed: 'Failed to confirm absence.',
    pickupChangeConfirmationFailed: 'Failed to confirm pickup change.',
    invalidEventPeriod: 'Event period specification is invalid.',
    guardianNotFound: 'Guardian not found.',
    duplicateAllergyFood: 'An allergy food with the same name is already registered.',
    allergyFoodNotOwned: 'The specified allergy food does not belong to this nursery.',
    staffAccountTitleExists: 'Staff account title already exists.',
    staffAccountTitleNotFound: 'Staff account title does not exist.',
    staffAccountInfoExists: 'Staff account information already exists.',
    staffAccountInfoNotFound: 'Staff account information does not exist.',
    staffTitleInUse: 'This staff account title cannot be deleted because it is currently in use.',
    endDateBeforeStartDate: 'End date is set after start date.',
    pastDateTime: 'The specified date/time is in the past.',
    excelGenerationFailed: 'Failed to generate Excel file. Please contact the system administrator.',
    napSensorNotStarted: 'Nap sensor is not started.',
    napSensorRecordNotFound: 'Nap sensor record not found.',
    absenceRegistrationNotFound: 'Absence registration not found.',
    chatReadOnly: 'Chats created by others can only be viewed.',
    emailInUse: 'The specified email address cannot be changed because it is being used by another user.',
    attachmentNotFound: 'Attachment file not found.',
    certificationNotFound: 'Certification/childcare fee record does not exist.',
    certificationEndDateRequired: 'Please enter the certification end date.',
    certificationPeriodOverlap: 'Certification/childcare fee period specification is invalid. Please check for overlaps with other periods.',
    accountTitleNotFound: 'Target account title not found.',
    accountTitleInUse: 'Account title cannot be deleted because it is used in petty cash records.',
    pettyCashDetailNotFound: 'Petty cash detail record not found.',
    duplicateAllergyItem: 'An allergy item with the same name is already registered.',
    allergyItemNotFound: 'Allergy item not found.',
    allergyItemCannotModify: 'The specified allergy item cannot be deleted or updated.',
    menuTypeNotFound: 'Menu type not found.',
    menuNotFound: 'Menu not found.',
    foodInspectionNotFound2: 'Food inspection not found.',
    foodInspectionAlreadyCreated: 'Food inspection has already been created.',
    extendedCarePatternNotFound: 'Extended care pattern not found.',
    timeSlotOverlap: 'Cannot save due to time slot overlap.',
    timeSlotNotFound: 'Time slot not found.',
    timeStampSettingNotFound: 'Time stamp settings do not exist.',
    extendedCareDiaryNotOwned: 'The specified extended care diary does not belong to this nursery.',
    nurseryServiceNotRegistered: 'The specified nursery-provided service is not registered in the master.',
    nurseryServiceAlreadyRegistered: 'The specified nursery-provided service is already registered.',
    nurseryServiceNotEnrolled: 'The specified nursery-provided service is not enrolled.',
    monthlyServiceSetDate: 'For monthly-based facility services, please set the 1st day of the month as the usage date.',
    nurseryServiceInUse: 'The specified facility-provided service cannot be deleted because it is in use.',
    invalidServiceType: 'The serviceType format of the facility-provided service is invalid.',
    invalidPaymentMonthType: 'The paymentMonthType format of the facility-provided service is invalid.',
    invalidAccountType: 'The accountType format of the facility-provided service is invalid.',
    userNotInManagementCompany: 'User does not belong to the specified management company.',
    managementCompanyNotFound: 'Management company not found.',
    invoiceNotFound: 'The specified invoice does not exist.',
    invalidInvoiceStatus: 'Invoice status is invalid.',
    invoiceNotConfirmed: 'Invoice has not been confirmed yet.',
    fileReadFailed: 'Failed to read file. Please check the CSV file format.',
    invalidChildCode: 'Child code in CSV file is invalid.',
    invalidReceivableValue: 'Receivable value in CSV file is invalid.',
    receivableImportNotFound: 'Receivable balance import status does not exist.',
    salesInfoSentCannotEdit: 'This arrival/departure record cannot be edited because sales information for this month has been sent.',
    pettyCashConfirmedCannotChange: 'Confirmed petty cash records cannot be changed.',
    salesConfirmedCannotEdit: 'Childcare fee/certification information for the period including the target period cannot be edited because sales information has been confirmed.',
    otherServiceDetailNotFound: 'The specified other service detail does not exist.',
    childWithoutCertification: 'There are children without childcare fee/certification information registered. Please set them before sending.',
    managementCompanyServiceNotFound: 'Management company service settings do not exist.',
    insufficientPermission: 'Due to insufficient permissions, the petty cash confirmation status cannot be released.',
    notDraftStatus: 'Cannot perform operation because status is not draft.',
    salesConfirmedCannotEdit2: 'Nursery-provided services for the period including the target period cannot be edited because sales information has been confirmed.',
    nurseryAccountNotFound: 'Nursery transfer account settings not found.',
    childAlreadyWithdrawn: 'This child has already withdrawn.',
    discussionNotFound: 'The specified discussion not found.',
    invalidGmoCardToken: 'GMO card token is invalid.',
    cardRegistrationFailed: 'An error occurred during card registration. Please check the card information.',
    gmoCardNotFound: 'GMO card information not found.',
    gmoCardDeleteFailed: 'An error occurred while deleting GMO card.',
    fileTooLarge: 'File cannot be sent because it exceeds 10MB.',
    emailNotVerified: 'Email has not been verified. Please check your email.',
    internalServerError: 'Internal Server Error',
    noDetailedErrorMessage: 'No detailed error message available',
    emailNotAvailable: 'This email address is not available',
  },
};
